import { Exception } from 'app/core/status';
import { useSurveyConfig } from 'app/core/survey-config';
import { Footer, InfoContainer } from 'app/shared/components';
import { Trans } from 'app/shared/i18n';
import { useRemoveLoading } from 'app/shared/utils/removeLoading';
import React, { FC } from 'react';
import { config } from './config';
import Reload from './Reload';

export interface ExceptionProps {
  exception: Exception;
}

const ExceptionPage: FC<ExceptionProps> = ({ exception }) => {
  const { statusCode, message } = exception;
  const surveyConfig = useSurveyConfig();
  const { image = '', title = '', info = '' } = config[statusCode]
    ? config[statusCode](surveyConfig)
    : {};

  useRemoveLoading();

  return (
    <div>
      <InfoContainer
        image={image}
        title={title}
        info={info && <Trans linebreak={<br />}>{info}</Trans>}
      >
        {message === 'INVALID_ANSWER_OBJECT' && <Reload />}
      </InfoContainer>
      <Footer />
    </div>
  );
};

export default ExceptionPage;
